import React from 'react';
import {avgFunc, fixIt} from "../../../../../components/functions/Mathematik";

function Xisob({locations}) {
    const mdata1 = localStorage.getItem('sfr-fao-mdata')
    const mdata = mdata1?JSON.parse(mdata1):[]
    const checkDate = (date) => {
        if(!isNaN(new Date(date))){
            return new Date(date).toISOString().slice(0,10)
        }
    }
    const dayOfYear = (date) => {
        if(!isNaN(new Date(date))) {
            let today = new Date(date)
            return Math.floor((today - new Date(today.getFullYear(), 0, 0)) / 1000 / 60 / 60 / 24)
        }
    }
    let e3 = (Math.PI/180)*locations.lat
    // const e3 = (Math.PI/180)*39.65417
    let x3 = 101.3 * Math.pow(((293 - 0.0065 * locations.alt) / 293),5.26)
    // const x3 = 101.3 * Math.pow(((293 - 0.0065 * 720) / 293),5.26)
    const y3 = x3 * 0.665 / 1000
    const addtd = (d,i) => {
        const yeardays = new Date(d.sana).getFullYear()%4==0?366:365
        let obj = [];
        let a3 = checkDate(d.sana)
        let b3 = avgFunc([d.max_xavo,d.min_xavo])
        let c3 = avgFunc([d.max_nam,d.min_nam])

        let d3 = d.shamol_tezlik*86.4
        let f3 = dayOfYear(d.sana)
        let g3 = (0.409*Math.sin(2*Math.PI*dayOfYear(d.sana)/yeardays-1.39))
        let h3 = Math.acos(-Math.tan(e3)*Math.tan(g3))
        let i3 = 1 + 0.033 * Math.cos((2 * Math.PI * yeardays)*f3)
        let j3 = ((24 * 60 / Math.PI * 0.082 * i3 * (h3 * Math.sin(e3) * Math.sin(g3) + Math.cos(e3) * Math.cos(g3) * Math.sin(h3))))
        let k3 = (24 / Math.PI) * h3
        let l3 = j3 * (0.25 + 0.5 * d.kun_soat / k3)
        let m3 = (0.75 + ((2 * Math.pow(10,-5)) * locations.alt)) * j3
        // let m3 = (0.75 + ((2 * Math.pow(10,-5)) * 720)) * j3
        let n3 = 0.77 * l3
        let o3 = 0.6108 * Math.exp((17.27 * d.max_xavo)/(d.max_xavo + 237.3))
        let p3 = 0.6108 * Math.exp((17.27 * d.min_xavo)/(d.min_xavo + 237.3))
        let q3 = avgFunc([o3,p3])
        let r3 = 0.5 * (o3 * d.min_nam + p3 * d.max_nam) / 100
        let s3 = 4.903 * Math.pow(10,-9) * Math.pow((d.max_xavo + 273.16),4)
        let t3 = 4.903 * Math.pow(10,-9) * Math.pow((d.min_xavo + 273.16),4)
        let u3 = ((s3 + t3) / 2) * (0.34 - 0.14 * Math.pow(r3,0.5)) * (1.35 * (l3 / m3) - 0.35)
        let v3 = n3 - u3
        let w3 = 0


        let z3 = 4098 * 0.6108 * Math.exp(17.27 * b3 / (b3 + 237.3)) / Math.pow((b3 + 237.3),2)
        obj.push(
            <tr key={i}>
                <td className="text-nowrap">{a3}</td>
                <td>{fixIt(b3)}</td>
                <td>{fixIt(c3,0)}</td>
                <td>{fixIt(d3)}</td>
                {
                    i==2?<td rowSpan={mdata.length-2} className="vertical-top">
                        <span style={{position:"sticky", top:"25vh"}}>{fixIt(e3)}</span>
                    </td>:null
                }
                <td>{f3}</td>
                <td>{fixIt(g3)}</td>
                <td>{fixIt(h3)}</td>
                <td>{fixIt(i3)}</td>
                <td>{fixIt(j3,1)}</td>
                <td>{fixIt(k3)}</td>
                <td>{fixIt(l3)}</td>
                <td>{fixIt(m3)}</td>
                <td>{fixIt(n3)}</td>
                <td>{fixIt(o3)}</td>
                <td>{fixIt(p3)}</td>
                <td>{fixIt(q3)}</td>
                <td>{fixIt(r3)}</td>
                <td>{fixIt(s3)}</td>
                <td>{fixIt(t3)}</td>
                <td>{fixIt(u3)}</td>
                <td>{fixIt(v3)}</td>
                <td>{w3}</td>
                {
                    i==2?<td rowSpan={mdata.length-2} className="vertical-top">
                        <span style={{position:"sticky", top:"25vh"}}>{fixIt(x3)}</span>
                    </td>:null
                }
                {
                    i==2?<td rowSpan={mdata.length-2} className="vertical-top">
                        <span style={{position:"sticky", top:"25vh"}}>{fixIt(y3,4)}</span>
                    </td>:null
                }
                <td>{fixIt(z3,4)}</td>
            </tr>
        )
        return obj;
    }
    return (
        <div className="row pt-3">
            <div className="col-12">
                <div className="flextable" style={{height:"85vh"}}>
                    <table className="table table-bordered tableFixHead fao-table meteoxisob">
                        <thead style={{background:"#fff"}}>
                        <tr>
                            <th className="outlined" rowSpan={2}>Sana</th>
                            <th className="outlined">O'rtacha xarorat, &#8451;</th>
                            <th className="outlined">O'rtacha namlik, %</th>
                            <th className="outlined">Shamol tezligi, km/sutka</th>
                            <th className="outlined">Kenglik radianda, rad</th>
                            <th className="outlined">Yildagi kun tartibi</th>
                            <th className="outlined">Quyosh burchagi, rad</th>
                            <th className="outlined">Quyosh botish burchagi, rad</th>
                            <th className="outlined">Yer va quyosh orasidagi teskar nisbiy masofa</th>
                            <th className="outlined">Yerdan tashqari quyosh radiatsiyasi</th>
                            <th className="outlined">Maksimal yorug' kun davomiyligi, soat</th>
                            <th className="outlined">Quyosh (qisqa to'lqinli) radiatsiyasi</th>
                            <th className="outlined">Ochiq osmon sharoitida quyosh (qisaq to'lqinli) radiatsiyasi</th>
                            <th className="outlined">Asl quyosh (qisqa to'lqinli) radiatsiyasi</th>
                            <th className="outlined">Maksimal xaroratda tuyingan bug‘ bosimi</th>
                            <th className="outlined">Minimal xaroratda tuyingan bug‘ bosimi</th>
                            <th className="outlined">Tuyingan bug‘ bosimi</th>
                            <th className="outlined">Bug‘ning xaqiqiy bosimi</th>
                            <th className="outlined" colSpan={2}>Stefan- Boltsman doimiysini xaroratning 4 darajasiga ko‘paytmasi</th>
                            <th className="outlined">Asl uzun tulqinli radiatsiya (erdan qaytgan)</th>
                            <th className="outlined">Asl radiatsiya</th>
                            <th className="outlined">Tuproq issiqlik oqimi</th>
                            <th className="outlined">Atmosfera bosimi, kPa</th>
                            <th className="outlined">Psixrometrik doimiy</th>
                            <th className="outlined">Bug‘ bosimi gradienti, kPa/S</th>
                        </tr>
                        <tr>
                            <td className="outlined">Т</td>
                            <td className="outlined"></td>
                            <td className="outlined">u<sub>2</sub></td>
                            <td className="outlined">&phi;</td>
                            <td className="outlined"><i>J</i></td>
                            <td className="outlined">&delta;</td>
                            <td className="outlined">&omega;<sub>s</sub></td>
                            <td className="outlined">d<sub>r</sub></td>
                            <td className="outlined">R<sub>a</sub></td>
                            <td className="outlined">N</td>
                            <td className="outlined">R<sub>s</sub></td>
                            <td className="outlined">R<sub>so</sub></td>
                            <td className="outlined">R<sub>ns</sub></td>
                            <td className="outlined">e<sup>0</sup>(T<sub>max</sub>)</td>
                            <td className="outlined">e<sup>0</sup>(T<sub>min</sub>)</td>
                            <td className="outlined">e<sub>s</sub></td>
                            <td className="outlined">е<sub>a</sub></td>
                            <td className="outlined">σ*T<sub>max</sub><sup>4</sup></td>
                            <td className="outlined">σ*T<sub>min</sub><sup>4</sup></td>
                            <td className="outlined">R<sub>nl</sub></td>
                            <td className="outlined">R<sub>n</sub></td>
                            <td className="outlined">G</td>
                            <td className="outlined">P</td>
                            <td className="outlined">&gamma;</td>
                            <td className="outlined">&Delta;</td>
                        </tr>
                        </thead >
                        <tbody>
                        {
                            mdata.length?
                                mdata.map((d,i)=>{
                                    if(i > 1){
                                        return addtd(d,i)
                                    }
                                })
                                :null
                        }
                        </tbody>
                    </table>
                </div>
            </div>

        </div>
    );
}

export default Xisob;